import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRelationshipRole } from '../../Interfaces/IRelationshipRole';

const initialState = { storeRelationshipRole: [] as IRelationshipRole[] };

const sliceRelationshipRole = createSlice({
  name: 'RELATIONSHIPROLE',
  initialState,
  reducers: {
    setRelationshipRoleArray: (
      state,
      action: PayloadAction<IRelationshipRole[]>
    ) => {
      state.storeRelationshipRole = [...action.payload];
    },
    addUpdateRelationshipRoleArray: (
      state,
      action: PayloadAction<IRelationshipRole>
    ) => {
      const testObject = state.storeRelationshipRole.find(
        x => x.idRelationshipRole === action.payload.idRelationshipRole
      );

      if (testObject) {
        state.storeRelationshipRole = [
          ...state.storeRelationshipRole.map(x =>
            x.idRelationshipRole === action.payload.idRelationshipRole
              ? action.payload
              : x
          ),
        ];
      } else {
        state.storeRelationshipRole = [
          action.payload,
          ...state.storeRelationshipRole,
        ];
      }
    },
  },
});
export const { setRelationshipRoleArray, addUpdateRelationshipRoleArray } =
  sliceRelationshipRole.actions;
export default sliceRelationshipRole.reducer;
